import { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ButtonLink from '@hiredigital/ui/Button/NextButtonLink';
import Styles from './Profile.module.scss';

const StickyProfileHeader = memo(({ user, hasToken }) => {
  return (
    <div className={classNames(Styles.section, Styles.floating)}>
      {user.profile && (
        <img
          className={Styles.floatingPicture}
          src={user.profile && user.profile.picture}
          alt={user.name}
        />
      )}
      <div className={Styles.floatingParent}>
        <p className={Styles.floatingName}>{user.name}</p>
        {user.profile && <p className={Styles.floatingProfileHeadline}>{user.profile.headline}</p>}
        {user.portfolio?.primarySkill && (
          <p className={Styles.floatingPrimarySkill}>{user.portfolio.primarySkill.noun}</p>
        )}
      </div>
      <div className={Styles.floatingCta}>
        {/* More verbose, but better user experience */}
        {hasToken ? (
          <ButtonLink
            type={ButtonLink.Type.DARKBLUE}
            title='Work With Talent'
            href={`${process.env.NEXT_PUBLIC_SITE_URL}/login?next=${encodeURIComponent(
              process.env.NEXT_PUBLIC_APP_URL + `/briefs/`
            )}`}>
            {`Hire ${user.firstName}`}
          </ButtonLink>
        ) : (
          <ButtonLink
            type={ButtonLink.Type.DARKBLUE}
            title='Work With Talent'
            href={{
              pathname: '/get-started',
              query: { talentName: user.username },
            }}>
            {`Hire ${user.firstName}`}
          </ButtonLink>
        )}
      </div>
    </div>
  );
});

StickyProfileHeader.propTypes = {
  className: PropTypes.string,
};

export default StickyProfileHeader;
